import React, { useState } from 'react';
import { toMMDDYYYY } from '../utils/dateFormat';
import '../styles/transaction.css';

function ExpenseModal({ person, onClose, onSave, existingExpense = null }) {
  const isEditMode = !!existingExpense;
  const [formData, setFormData] = useState({
    amount: existingExpense?.amount?.toString() || '',
    date: existingExpense?.date 
      ? new Date(existingExpense.date.split('/').reverse().join('-')).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0],
    description: existingExpense?.description || ''
  });

  const handleSubmit = () => {
    if (!formData.amount || !formData.description) {
      alert('Amount and description are required!');
      return;
    }

    const amount = parseFloat(formData.amount);
    if (isNaN(amount) || amount <= 0) {
      alert('Please enter a valid amount!');
      return;
    }

    const expense = {
      id: Date.now(),
      amount,
      date: toMMDDYYYY(formData.date),
      description: formData.description.trim(),
      createdAt: new Date().toISOString()
    };

    onSave(expense);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="transaction-modal expense-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? '✏️ Edit' : '➖ Add'} Expense - {person?.name || person?.code}</h3>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="form-field">
            <label>Amount ($)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              placeholder="120.50"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            />
          </div>

          <div className="form-field">
            <label>Date</label>
            <input
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
            />
          </div>

          <div className="form-field">
            <label>What was it spent for?</label>
            <input
              type="text"
              placeholder="Amazon Ads, Rent, Material..."
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-save" onClick={handleSubmit}>
            {isEditMode ? '💾 Update' : '💾 Add'} Expense
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExpenseModal;
